import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {User} from '../../../models/user';
import {environment} from '../../../../environments/environment';
import {AuthControllerService} from '../../../services/auth-controller/auth-controller.service';
import {UserLangResolverService} from '../../../services/user-lang-resolver';
import {AuthRESTService} from "../../services/rest/auth-rest.service";
import {Partner} from "../../../models/partner";
import { TranslateService} from '@ngx-translate/core';
import { SharedModule } from 'app/shared.module';

@Component({
    standalone: true,
    imports: [SharedModule],
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.css'],
    providers: [AuthControllerService],
})
export class LoginPage implements OnInit {

    user: User = new User();
    error: boolean;
    password: string;
    emailToRestore: string;
    showRestoreForm: boolean = false;
    OAuthRedirectUrl: string = environment.OAuthRedirectUrl;
    authUrl: string = environment.authUrl;
    OAuthClientId: string = environment.OAuthClientId;
    randomHash: string;
	showRegisteredMessage: boolean;
	userLangResolver: UserLangResolverService;
    casBaseUrl: string = environment.casBaseUrl;
    partners: Array<Partner>;
    systemCode: string = '';

    constructor(private rest: AuthRESTService,
                private authService: AuthControllerService,
                private router: Router,
                private http: HttpClient,
                public translate: TranslateService, userLangResolver: UserLangResolverService) {
		this.userLangResolver = userLangResolver;
    this.randomHash = this.authService.randomId()
    }

    ngOnInit() {
        this.error = this.authService.getSearchParameters().error;
        if (this.authService.isAnyTokenPresent()) {
            this.authService.logout();
        }
        this.showRegisteredMessage = AuthControllerService.showRegisteredMessage;
        this.randomHash = this.authService.randomId();
        this.rest.get('cas/configuration/settings').subscribe((res) => {
            this.systemCode = res.code;
            this.rest.get('cas/configuration/partners').subscribe((res) => {
                this.partners = res.sort((a, b) => { return a.order - b.order; });
            }, err => this.partners = []);
        }, err => this.partners = []);

    }

    requestNewPassword(): void {
        this.error = false;
        if (this.emailToRestore) {
            this.authService.requestNewPassword(this.emailToRestore);
        }
    }

}
